import { Component, Input, OnInit } from '@angular/core';
import { CategoryAvailableReservations } from 'projects/qcloud-models/reservation-plugin/category-available-reservations';
import { TicketReservationPlugin } from 'projects/qcloud-models/reservation-plugin/ticket-reservation-plugin';
import { TicketReservationService } from '../../../services/ticket-reservation.service';
import { TimeService } from '../../../services/time.service';

@Component({
  selector: 'app-reservation-times',
  templateUrl: './reservation-times.component.html',
  styleUrls: ['./reservation-times.component.scss']
})
export class ReservationTimesComponent implements OnInit {

  @Input() availableTimes: Map<number, CategoryAvailableReservations>;
  ticketReservation = new TicketReservationPlugin();
  availableReservationIdx: number;
  categoryAvailableReservations: CategoryAvailableReservations;
  previousDate = new Date();

  constructor(private ticketReservationService: TicketReservationService, private timeService: TimeService) {
    ticketReservationService.ticketReservation.subscribe((val: TicketReservationPlugin) => {
      this.ticketReservation = val;
      if (!this.timeService.sameDay(this.previousDate, new Date(this.ticketReservation.reservationTime)))
      {
        this.availableReservationIdx = -1;
      }
      this.previousDate = new Date(val.reservationTime);
      this.getAvailableReservationTimes();
    });
  }

  ngOnInit(): void {
  }

  getAvailableReservationTimes() {
    this.categoryAvailableReservations = new CategoryAvailableReservations();
    if (this.ticketReservation.categoryId && this.ticketReservation.reservationTime) {
      this.categoryAvailableReservations.availableReservations = this.availableTimes[this.ticketReservation.categoryId]
        .availableReservations;
      this.categoryAvailableReservations.availableReservations = 
        this.categoryAvailableReservations.availableReservations.filter(
          x => this.timeService.sameDay(new Date(x.reservationTime), new Date(this.ticketReservation.reservationTime)));
    }
  }

  selectReservationTime(idx: number) {
    this.availableReservationIdx = idx;
    let reservationTime = new Date(this.categoryAvailableReservations.availableReservations[idx].reservationTime + "Z");
    this.ticketReservation.reservationTime.setHours(reservationTime.getHours());
    this.ticketReservation.reservationTime.setMinutes(reservationTime.getMinutes());
    this.ticketReservationService.updateTicketReservation(this.ticketReservation);
  }

  checkIfAnyReservationAvailable() {
    return this.categoryAvailableReservations.availableReservations.length > 0;
  }

}
